import { ModelBase } from '../../abstract/model-base.model';
import { Account } from '../../accounting/account.model';
import { Journal } from '../../accounting/journal.model';
import { BankAccount } from '../bank-accounts/bank-account.model';

export class CreditCard extends ModelBase {

    static override CLASS_NAME: string = 'CreditCard';

    private _account!: Account;
    private _bankAccount!: BankAccount;
    private _journal!: Journal;
    private _label!: string;

    public override toString(): string {
        if (!!this.bankAccount && !!this.label) {
            return `${this.label} - ${this.bankAccount.label}`;
        } else if (!!this.label) {
            return this.label;
        }
        return '';
    }

    public get bankAccount(): BankAccount {
        return this._bankAccount;
    }

    public set bankAccount(value: any) {
        this._setValue('_bankAccount', value, 'BankAccount');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get account(): Account {
        return this._account;
    }

    public set account(value: any) {
        this._setValue('_account', value, 'Account');
    }

    public get journal(): Journal {
        return this._journal;
    }

    public set journal(value: any) {
        this._setValue('_journal', value, 'Journal');
    }

}
